import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { reportsApi } from '../../services/reports';

function ReportsList() {
  const [lastWeekData, setLastWeekData] = useState(null);
  const [thisWeekData, setThisWeekData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedReport, setSelectedReport] = useState('last-week');

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      setLoading(true);
      const [lastWeek, thisWeek] = await Promise.all([
        reportsApi.getMissingTimesheetsLastWeek(),
        reportsApi.getMissingTimesheetsThisWeek()
      ]);
      setLastWeekData(lastWeek);
      setThisWeekData(thisWeek);
    } catch (err) {
      console.error('Failed to load reports:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatWeekRange = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const monday = new Date(date);
    const sunday = new Date(date);
    sunday.setDate(monday.getDate() + 6);
    
    return `${monday.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })} - ${sunday.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}`;
  };

  const getDisplayData = () => {
    return selectedReport === 'last-week' ? lastWeekData : thisWeekData;
  };

  const exportToCSV = (data, reportType) => {
    if (!data || !data.employees || data.employees.length === 0) return;
    
    const headers = ['Employee Name', 'Email', 'Department', 'Role'];
    const rows = data.employees.map(emp => [
      emp.name,
      emp.email,
      emp.department,
      emp.role
    ]);
    
    const csvContent = [headers, ...rows]
      .map(row => row.map(cell => `"${cell}"`).join(','))
      .join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `missing_timesheets_${reportType}_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  const displayData = getDisplayData();

  return (
    <div>
      <div className="page-header">
        <h2>Timesheet Compliance Reports</h2>
      </div>

      <div className="card">
        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
            Select Report:
          </label>
          <select
            className="form-control"
            value={selectedReport}
            onChange={(e) => setSelectedReport(e.target.value)}
            style={{ maxWidth: '400px' }}
          >
            <option value="last-week">Timesheet not filled last week</option>
            <option value="this-week">Timesheet not filled this week</option>
          </select>
        </div>

        {displayData && (
          <>
            <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: 'rgba(33, 150, 243, 0.1)', borderRadius: '4px' }}>
              <strong>Week:</strong> {formatWeekRange(displayData.week_start_date)}
              <span style={{ marginLeft: '16px' }}>
                <strong>Count:</strong> {displayData.employees?.length || 0} employee(s)
              </span>
            </div>

            {displayData.employees && displayData.employees.length > 0 ? (
              <>
                <div style={{ marginBottom: '16px' }}>
                  <button 
                    className="btn btn-primary btn-compact" 
                    onClick={() => exportToCSV(displayData, selectedReport)}
                  >
                    Export CSV
                  </button>
                </div>
                <div className="table-container" style={{ overflowX: 'auto' }}>
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Employee Name</th>
                        <th>Email</th>
                        <th>Department</th>
                        <th>Role</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayData.employees.map(employee => (
                        <tr key={employee.id}>
                          <td>
                            <Link 
                              to={`/employees/${employee.id}`} 
                              style={{ textDecoration: 'none', color: '#1976d2' }}
                            >
                              {employee.name}
                            </Link>
                          </td>
                          <td>{employee.email}</td>
                          <td>{employee.department}</td>
                          <td>{employee.role}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <p style={{ color: 'rgba(255,255,255,0.5)', padding: '20px 0' }}>
                All employees have filled their timesheets for this period.
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default ReportsList;
